import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MD5 from 'js-md5'
import styles from './ListItem.module.css'
import { Button, Divider, Drawer, Flex, message, Modal, Rate, Tooltip } from 'antd'
import classNames from 'classnames'
import xuanzongStar from './xuanzhong.svg'
import weixuanzongStar from './weixuanzhong.svg'
import { HeartFilled, HeartOutlined } from '@ant-design/icons'
import goldIcon from './goldIcon.svg'
import jiaoxueIcon from './jiaoxue.svg'
export default function ListItem(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  return (
    <div
      className={classNames(
        styles.background,
        props.boxWidth < 1000
          ? styles.backgroundWidth2
          : props.boxWidth < 1500
            ? styles.backgroundWidth3
            : props.boxWidth < 2000
              ? styles.backgroundWidth4
              : styles.backgroundWidth5,
      )}
      onClick={() => {
        props.clickMethod()
      }}
    >
      {props.showPoints?<div className={styles.goldDiv}>
        <img src={goldIcon} style={{width:12}} />
        <text style={{ marginLeft: 4,marginTop:-2 }}>{props.info.xiaohao_jifen}</text>
      </div>:null}
      <img src={props.info.icon_url} className={styles.headerImg} />
      <Divider
        type="vertical"
        variant="dashed"
        orientation="left"
        style={{
          borderColor: '#f5b544',
          marginLeft: '4%',
          height: '62%',
          marginTop: 2,
        }}
      />
      {props.info.video_status == 1 ? (
          <img
            className={styles.questionIcon}
            src={jiaoxueIcon}
            onClick={(e) => {
              props.playVideo(props.info.video_ali_id)
              e.stopPropagation()
              e.preventDefault()
            }}
          />
        ) : null}
      <img
        className={styles.starIcon}
        src={props.info.shoucang_status == 1 ? xuanzongStar : weixuanzongStar}
        onClick={(e) => {
          props.collectMethod()
          e.stopPropagation()
          e.preventDefault()
        }}
      ></img>
      <div className={styles.rightContainer}>
        <div className={styles.rightTitle}>{props.info.title}</div>
        <div className={styles.ringhtDes}>
          <Tooltip placement="top" title={props.info.des}>
            <text>{props.info.des}</text>
          </Tooltip>
          {/* {props.info.des} */}
          </div>
        <div
          className={styles.commentContainer}
          onClick={(e) => {
            props.openDrawer()
            e.stopPropagation()
            e.preventDefault()
          }}
        >
          <text className={styles.commentTitle}>综合评分</text>
          <Rate
            character={<HeartFilled />}
            allowHalf
            disabled
            value={props.info.zonghe_pingfen / 20}
          />
        </div>
      </div>
    </div>
  )
}
